/**
 * @generated SignedSource<<a6e72eeac6ff31255b866b292a0cd20d>>
 * @relayHash bdc56840d49534f36aafdde4bcb4fb2d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5c37bebfdb7f84ec1d5b68de3ebd9284e214b097de7de443e3b40f6ea8bf4147

import type { ConcreteRequest, Query } from 'relay-runtime';
export type PopularQuestionsQuery$variables = {
  cloudId: string;
  spaceKey: string;
};
export type PopularQuestionsQuery$data = {
  readonly confluence_smartSpaceOverview: {
    readonly faq: {
      readonly entries: ReadonlyArray<{
        readonly answer: string;
        readonly followUpQuestions: ReadonlyArray<string | null | undefined>;
        readonly question: string;
        readonly sources: ReadonlyArray<{
          readonly content: {
            readonly embeddedProduct: string | null | undefined;
            readonly excerpt: string;
            readonly id: string | null | undefined;
            readonly links: {
              readonly webui: string | null | undefined;
            } | null | undefined;
            readonly title: string | null | undefined;
          } | null | undefined;
        }>;
      }>;
    } | null | undefined;
  } | null | undefined;
};
export type PopularQuestionsQuery = {
  response: PopularQuestionsQuery$data;
  variables: PopularQuestionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "ConfluenceSmartSpaceOverview",
    "kind": "LinkedField",
    "name": "confluence_smartSpaceOverview",
    "plural": false,
    "selections": [
      {
        "concreteType": "ConfluenceSmartSpaceOverviewFAQ",
        "kind": "LinkedField",
        "name": "faq",
        "plural": false,
        "selections": [
          {
            "concreteType": "ConfluenceSmartSpaceOverviewFAQEntry",
            "kind": "LinkedField",
            "name": "entries",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "question"
              },
              {
                "kind": "ScalarField",
                "name": "answer"
              },
              {
                "kind": "ScalarField",
                "name": "followUpQuestions"
              },
              {
                "concreteType": "ConfluenceSmartSpaceOverviewFAQSource",
                "kind": "LinkedField",
                "name": "sources",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "title"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "excerpt"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "embeddedProduct"
                      },
                      {
                        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                        "kind": "LinkedField",
                        "name": "links",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "webui"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "PopularQuestionsQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PopularQuestionsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "bdc56840d49534f36aafdde4bcb4fb2d",
    "id": "5c37bebfdb7f84ec1d5b68de3ebd9284e214b097de7de443e3b40f6ea8bf4147",
    "metadata": {},
    "name": "PopularQuestionsQuery",
    "operationKind": "query",
    "text": "query PopularQuestionsQuery($cloudId:ID!,$spaceKey:String!){confluence_smartSpaceOverview(spaceKey:$spaceKey,cloudId:$cloudId){faq{entries{question,answer,followUpQuestions,sources{content{id,title,excerpt,embeddedProduct,links{webui}}}}}}}"
  }
};
})();

(node as any).hash = "061c6bb7810773c1cb918ceac9b4c3f7";

export default node;
